import { GraphQLClient, gql } from 'graphql-request';
const graphQl = async function graphql(url, query) {
    
    try {
        // create a new client with the url
        const client = new GraphQLClient('http://studies.test/graphql');

        // send the query from above and wait for an answer
        const data = await client.request(query);

        return data;
    } 
    catch (e) {
        console.log("No GraphQL received: " + e);
    }

};
export default graphQl 